/**
 * Metric
 */

// Inputs
export const SET_ALTITUDE_METERS = 'SET_ALTITUDE_METERS';
export const SET_OVEN_TEMP_C = 'SET_OVEN_TEMP_C';
export const SET_BAKING_MINS_METRIC = 'SET_BAKING_MINS_METRIC';
export const SET_BAKING_HOURS_METRIC = 'SET_BAKING_HOURS_METRIC ';
export const SET_LIQUID_GRAMS = 'SET_LIQUID_GRAMS';
export const SET_FLOUR_GRAMS = 'SET_FLOUR_GRAMS';
export const SET_SUGAR_GRAMS = 'SET_SUGAR_GRAMS';
export const SET_BAKING_POWDER_GRAMS = 'SET_BAKING_POWDER_GRAMS';
export const SET_YEAST_GRAMS = 'SET_YEAST_GRAMS';
export const SET_BAKING_SODA_GRAMS = 'SET_BAKING_SODA_GRAMS';

export const CALCULATE_MIN_OVEN_TEMP_METRIC = 'CALCULATE_MIN_OVEN_TEMP_METRIC';
export const CALCULATE_MAX_OVEN_TEMP_METRIC = 'CALCULATE_MAX_OVEN_TEMP_METRIC';
export const CALCULATE_MIN_TIME_METRIC = 'CALCULATE_MIN_TIME_METRIC';
export const CALCULATE_MAX_TIME_METRIC = 'CALCULATE_MAX_TIME_METRIC';
export const CALCULATE_BAKING_POWDER_GRAMS = 'CALCULATE_BAKING_POWDER_GRAMS';

export const CALCULATE_YEAST_GRAMS = 'CALCULATE_YEAST_GRAMS';
export const CALCULATE_FLOUR_GRAMS = 'CALCULATE_FLOUR_GRAMS';
export const CALCULATE_MIN_LIQUID_GRAMS = 'CALCULATE_MIN_LIQUID_GRAMS';
export const CALCULATE_MAX_LIQUID_GRAMS = 'CALCULATE_MAX_LIQUID_GRAMS';
export const CALCULATE_SUGAR_GRAMS = 'CALCULATE_SUGAR_GRAMS';
export const CALCULATE_BAKING_SODA_GRAMS = 'CALCULATE_BAKING_SODA_GRAMS';
export const SET_DISPLAY_TEMP_C = 'SET_DISPLAY_TEMP_C';
export const SET_DISPLAY_TIME_METRIC = 'SET_DISPLAY_TIME_METRIC';
export const SET_DISPLAY_FLOUR_GRAMS = 'SET_DISPLAY_FLOUR_GRAMS';
export const SET_DISPLAY_LIQUID_GRAMS = 'SET_DISPLAY_LIQUID_GRAMS';
export const SET_DISPLAY_SUGAR_GRAMS = 'SET_DISPLAY_SUGAR_GRAMS';
export const SET_DISPLAY_YEAST_GRAMS = 'SET_DISPLAY_YEAST_GRAMS';
export const SET_DISPLAY_BAKING_POWDER_GRAMS = 'SET_DISPLAY_BAKING_POWDER_GRAMS';
export const SET_DISPLAY_BAKING_SODA_GRAMS = 'SET_DISPLAY_BAKING_SODA_GRAMS';

// Form actions
export const CLEAR_FORM = 'CLEAR_FORM';
